module.exports = __webpack_public_path__ + "static/media/42x42-1.c73d3f2f.png";